module.exports = __webpack_public_path__ + "static/media/file-invoice-solid_x.36a0a070.svg";